import { type ReactNode } from 'react';
import { PageUrl } from '../../../constants/PageUrl';
import { BlogCtaCard } from '../BlogCtaCard';
import { type ArticleCtaPosition } from '../BlogCtaCard/ctaPosition';

type Props = {
  heading?: ReactNode;
  subtext?: string;
  ctaLabel?: string;
  dataTrackingId?: string;
  eventName?: string;
  ctaPosition?: ArticleCtaPosition;
};

const DEFAULT_HEADING_WITH_WBR = (
  <>
    あなたの子育ての悩みを、
    <wbr />
    31問・約5分で診断
  </>
);

const DEFAULT_SUBTEXT =
  '5タイプの気質バランスを無料で診断。お子さんに合ったモンテッソーリの関わり方が見つかります。登録不要。';
const DEFAULT_CTA_LABEL = '無料で気質を診断する →';
const DEFAULT_EVENT_NAME = 'diagnosis_cta_click';
const DEFAULT_DATA_TRACKING_ID = 'diagnosis-cta';

export const DiagnosisCta = ({
  heading = DEFAULT_HEADING_WITH_WBR,
  subtext = DEFAULT_SUBTEXT,
  ctaLabel = DEFAULT_CTA_LABEL,
  dataTrackingId = DEFAULT_DATA_TRACKING_ID,
  eventName = DEFAULT_EVENT_NAME,
  ctaPosition,
}: Props) => {
  const handleClick = () => {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(
      ctaPosition === undefined ? { event: eventName } : { event: eventName, cta_position: ctaPosition }
    );
  };

  return (
    <BlogCtaCard
      theme="diagnosis"
      ctaType="diagnosis"
      ctaPosition={ctaPosition}
      layoutVariant="sideBySideNoOverlay"
      imageCropVariant="centered"
      heading={heading}
      subtext={subtext}
      ctaLabel={ctaLabel}
      href={PageUrl.DIAGNOSIS_ROOT}
      dataTrackingId={dataTrackingId}
      imageSrc="/img/diagnosis-cta-personality-types.png"
      imageAlt="診断のイメージ"
      onCtaClick={handleClick}
    />
  );
};
